module.exports = __webpack_public_path__ + "static/media/WEBM.6743fa4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/WEBM.svg
// module id = 1682
// module chunks = 17